import { Component, OnInit, OnDestroy, Input, AfterViewInit, ViewChild, ElementRef, EventEmitter, Output, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { UserLogin } from '../../models/user-login.model';
import { ICD, MasterConfig, ResponseAPI, ErrorList, ICDStep3 } from '../../models/IDPReport.model';
import { SfDataService } from '../../services/sf-data.service';
import { AgentService, PreSubmitIssue } from '../../services/agent.service';
import { AiHintStateService } from '../../services/ai-hint-state.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Utilities } from '../../services/utilities';


import Swal from 'sweetalert2';
import { environment } from './../../../environments/environment';

declare global {
  interface JQuery {
    datepicker(options?: any): any;
  }
}

interface JQuery<TElement = HTMLElement> {
  select2(options?: any): any;
}

interface JQuery {
  select2(options?: any): any;
}

// import custom validator to validate 
import { MustMatch } from '../../models/MustMatch';
import { dateNotLessThanTodayValidator } from '../../models/dateNotLessThanTodayValidator';


@Component({
    selector: 'app-sf-icd-acknowledge',
    templateUrl: './sf-icd-acknowledge.component.html',
    styleUrls: ['./sf-icd-acknowledge.component.scss'],
    standalone: false
})
export class SfIcdAcknowledgeComponent implements OnInit {
  icd = new ICDStep3();
  data = {
    name: 'John',
    age: 30
  };

  userLogin = new UserLogin(); id: string; q: string;
  isLoading = false;
  isTestCampaign = false;
  formResetToggle = true;
  modalClosedCallback: () => void;
  loginStatusSubscription: any;
  selectedCountry: string;
  selected_WC_details: string
  icdForm: FormGroup;
  @Input()
  isModal = false;
  submitted = false;
  ddlUSStates = [];
  ddlBest_Delivery_Time = [];
  ddlCAProvinence = [];
  displayValue: string = '';
  ssnValue: string = '';
  isUS: boolean = true;
  secondaryOwner: string = '';   // Feature 10 — concatenated secondary owner name (read-only display)

  Canada_campaignData = [];
  Canada_retailsData = [];
  US_campaignData = [];
  US_retailsData = [];
  icd_o = new ICD();
  @Output() dataEmitter = new EventEmitter<any>();
  @Input() inputData: any;
  selectedFiles: FileList;
  validFiles: File[] = [];
  fileData: { attachment_FileName: string, attachment_Base64: string, attachment_Type: string }[] = [];
  maxFilesAllowed: number = 5; // Maximum number of files allowed
  maxFileSize: number = 26214400; // Maximum file size in bytes (5MB)

  US_Retails_selectedItems: any[] = [];
  US_Retails_isSelectedItemsinvalid = false;
  Canada_Retails_selectedItems: any[] = [];
  Canada_Retails_isSelectedItemsinvalid = false;
  US_Campaigns_selectedItems: any[] = [];
  US_Campaigns_isSelectedItemsinvalid = false;
  Canada_Campaigns_selectedItems: any[] = [];
  Canada_Campaigns_isSelectedItemsinvalid = false;
  isOTPValid = false;
  btnDisplay = true;
  // Pre-submit review
  showPreSubmitReview = false;
  preSubmitIssues: PreSubmitIssue[] = [];
  preSubmitLoading = false;

  public masterConfig: MasterConfig[] = [];

  datad = {
    name: '',
    age: 0
  };

  @Output() idEmitter = new EventEmitter<string>();
  //@ViewChild('dobInput') dobInput: ElementRef;
  @ViewChild('datepicker') datepicker: ElementRef;
  @ViewChild('selectEl') selectEl: ElementRef;

  select2Options = {
    placeholder: 'Select an option...',
    width: '100%'
  };

  selectedOption: string;
  isHJbtn: boolean = false;

  controlDisplayNames: { [key: string]: string } = {
    Acknowledge: 'Acknowledgment'
  };

  constructor(private route: ActivatedRoute, private elRef: ElementRef, private fb: FormBuilder, private router: Router, private alertService: AlertService, private authService: AuthService, private configurations: ConfigurationService, private sfDataService: SfDataService, private agentService: AgentService, private hintStateService: AiHintStateService) { }

  @Output() activateTab = new EventEmitter<number>();

  ngOnInit(): void {


    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Attempting login...');
    //this.emitActivateTab(3);
    $('.detailchild').removeClass('active');
    $('.detailmain').removeClass('active');
    $('#custom-tabs-four-more-tab').removeClass('active');
    $('#custom-tabs-four-more-tab').parent().removeClass('active');
    $('#custom-tabs-four-messages-tab').addClass('active');
    $('#custom-tabs-four-messages-tab').parent().addClass('active');

    this.id = this.route.snapshot.paramMap.get('id');

    this.q = this.route.snapshot.paramMap.get('query');
    if (this.q != null) {

      this.ShowOTPpopup("Enter Access Code to continue");
      $('#custom-tabs-four-home-tab').parent().addClass('hide');
      $('#custom-tabs-four-profile-tab').parent().addClass('hide');
      $('#custom-tabs-four-more-tab').parent().addClass('hide');
    }

    this.datad = this.inputData;
    this.CreateForm();

    
    this.BindDropdowns();

    

    if (this.id != null) {
      if (this.q != null && !this.isOTPValid) {

      }
      else {
        this.idEmitter.emit(this.id);
        this.BindData(this.id);
      }

    }

  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: Event): void {
    event.preventDefault();
  }

  Showsuccesspopup(str: string) {
    Swal.fire({
      title: str,
      icon: 'success',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {

        }
      },
    }).then((result) => {

    });
  }

  ShowOTPpopup(str: string) {
    Swal.fire({
      title: 'Access Code!',
      text: str,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,
      input: 'text',
      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (!val) {
          Swal.showValidationMessage("Access Code is required");
        } else {
          try {

            // Create a new instance of the ICD class
            let responseAPI = new ResponseAPI();
            this.sfDataService.getOTP(this.id, val, this.q)
              .subscribe(
                data => {

                  //responseAPI = data;
                  // Assign the received data to the responseAPI object
                  responseAPI = data;
                  if (responseAPI.isSuccess) {
                    this.isOTPValid = responseAPI.isSuccess;
                    this.idEmitter.emit(this.id);
                    this.BindData(this.id);
                  }
                  else {
                    // API call failed, reject the Promise to prevent closing the popup
                    this.ShowOTPpopup("Wrong Access Code, Enter Access Code to continue");
                  }

                },
                error => {

                  this.alertService.stopLoadingMessage();

                  if (Utilities.checkNoNetwork(error)) {
                    this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
                    this.offerAlternateHost();
                  } else {
                    const errorMessage = Utilities.getHttpResponseMessage(error);

                    if (errorMessage) {
                      this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
                    } else {
                      this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
                    }
                  }

                  setTimeout(() => {
                    this.isLoading = false;
                  }, 500);
                });

            // await this.apiService.postData(val);
            // API call succeeded, resolve the Promise
          } catch (error) {
            // API call failed, reject the Promise to prevent closing the popup
            return Promise.reject(error);
          }
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle success case when the API call is successful
      } else if (result.isDenied) {
        // Handle the case when the user cancels the dialog
      } else if (result.isDismissed) {
        // Handle the case when the dialog is closed without confirmation
      }
    });
  }

  CreateForm() {
    this.icdForm = this.fb.group({
      US_or_CA: [{ value: '', disabled: true }],
      Full_Legal_Company_Name: [{ value: '', disabled: true }],
      Tax_ID: [{ value: '', disabled: true }],
      State_of_Incorporation: [{ value: '', disabled: true }],
      Provinence_of_Incorporation: [{ value: '', disabled: true }],
      Years_in_Business: [{ value: '', disabled: true }],
      Date_of_Incorporation: [{ value: '', disabled: true }],
      Company_Address1: [{ value: '', disabled: true }],
      Company_Address2: [{ value: '', disabled: true }],
      Company_City: [{ value: '', disabled: true }],
      Company_Postal_Code: [{ value: '', disabled: true }],
      Company_Office_Phone: [{ value: '', disabled: true }],
      Company_Business_Email: [{ value: '', disabled: true }],
      Company_Country: [{ value: '', disabled: true }],
      Company_State: [{ value: '', disabled: true }],
      Company_Province: [{ value: '', disabled: true }],

      Owner_First_Name: [{ value: '', disabled: true }],
      Owner_Last_Name: [{ value: '', disabled: true }],
      Owner_Middle_Name: [{ value: '', disabled: true }],
      Owner_Preferred_First_Name: [{ value: '', disabled: true }],
      Owner_Preferred_Last_Name: [{ value: '', disabled: true }],
      Owner_Perc: [{ value: '', disabled: true }],
      Owner_Address1: [{ value: '', disabled: true }],
      Owner_Address2: [{ value: '', disabled: true }],
      Owner_City: [{ value: '', disabled: true }],
      Owner_Country: [{ value: '', disabled: true }],
      Owner_State: [{ value: '', disabled: true }],
      Owner_Province: [{ value: '', disabled: true }],
      Owner_Postal_Code: [{ value: '', disabled: true }],
      Owner_Mobile_Phone: [{ value: '', disabled: true }],
      Owner_Home_Phone: [{ value: '', disabled: true }],
      Owner_Email: [{ value: '', disabled: true }],


      HUB_Manager_Contact_Name: [{ value: '', disabled: true }],
      HUB_Manager_Contact_Number: [{ value: '', disabled: true }],
      HUB_Manager_Contact_Email: [{ value: '', disabled: true }],
      HUB_Manager_Contact: [''],

      SSN_SIN: [{ value: '', disabled: true }],
      Acknowledge: ['', [Validators.required]],


    });
  }
  sendDataToParent() {
    this.dataEmitter.emit(this.datad);
  }
  // convenience getter for easy access to form fields
  get f() { return this.icdForm.controls; }

  get items(): FormArray {
    return this.icdForm.get('items') as FormArray;
  }



  onCountryChange() {
    const US_or_CA = this.icdForm.get('US_or_CA').value;
    if (US_or_CA === 'US') {
      this.selectedCountry = "US";
      this.icdForm.get('State_of_Incorporation').setValidators([Validators.required]);
      this.icdForm.get('Provinence_of_Incorporation').clearValidators();

      this.icdForm.get('Owner_Country').setValidators([Validators.required]);
      this.icdForm.get('Owner_State').setValidators([Validators.required]);
      this.icdForm.get('Owner_Province').clearValidators();

      this.icdForm.get('Company_Country').setValidators([Validators.required]);
      this.icdForm.get('Company_State').setValidators([Validators.required]);
      this.icdForm.get('Company_Province').clearValidators();


    } else {
      this.selectedCountry = "Canada";
      this.icdForm.get('Provinence_of_Incorporation').setValidators([Validators.required]);
      this.icdForm.get('State_of_Incorporation').clearValidators();


      this.icdForm.get('Owner_Country').clearValidators();
      this.icdForm.get('Owner_State').clearValidators();
      this.icdForm.get('Owner_Province').setValidators([Validators.required]);

      this.icdForm.get('Company_Country').clearValidators();
      this.icdForm.get('Company_State').clearValidators();
      this.icdForm.get('Company_Province').setValidators([Validators.required]);




    }
    this.icdForm.get('Provinence_of_Incorporation').updateValueAndValidity();
    this.icdForm.get('State_of_Incorporation').updateValueAndValidity();


    this.icdForm.get('Owner_Country').updateValueAndValidity();
    this.icdForm.get('Owner_State').updateValueAndValidity();
    this.icdForm.get('Owner_Province').updateValueAndValidity();

    this.icdForm.get('Company_Country').updateValueAndValidity();
    this.icdForm.get('Company_State').updateValueAndValidity();
    this.icdForm.get('Company_Province').updateValueAndValidity();

  }


  showErrorAlert(caption: string, message: string) {
    this.alertService.showMessage(caption, message, MessageSeverity.error);
  }

  // Convert a Salesforce YYYY-MM-DD (optionally with a time component) to the
  // MM-DD-YYYY the UI displays. Safe for empty/invalid values.
  private toDisplayDate(v: string): string {
    if (!v) { return v; }
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v.trim());
    return m ? `${m[2]}-${m[3]}-${m[1]}` : v;
  }

  ngAfterViewInit() {

    
 
 
    //$(this.datepicker.nativeElement).datepicker({
    //  dateFormat: 'yyyy-mm-dd',
    //  autoclose: true,
    //  onSelect: (date) => {
    //    this.dobInput.nativeElement.value = date;
    //  }
    //});

    //$('.select2').select2(); //initialize 
  }

  closeModal() {
    if (this.modalClosedCallback) {
      this.modalClosedCallback();
    }
  }

  onSubmit() {
    this.hintStateService.collapse();

    this.submitted = true;

    this.trimFormValues();

    // stop here if form is invalid
    if (  this.icdForm.invalid) {

      // Mark all fields as touched to display validation errors
      this.icdForm.markAllAsTouched();
      this.alertService.showMessage('ICD', `Acknowledgment is required, Please select the checkbox`, MessageSeverity.error);
      this.Showsuccesspopup1('Acknowledgment is required, Please select the checkbox');
      return;
    }

    if (this.icdForm.value.Acknowledge == true) {
      this.showPreSubmitReview = true;
      this.runPreSubmitReview();
    }
    else {
      this.alertService.showMessage('ICD', `Acknowledgment is required, Please select the checkbox`, MessageSeverity.error);
      this.Showsuccesspopup1('Acknowledgment is required, Please select the checkbox');
      return;
    }
    

  }



  Showsuccesspopup1(str: string) {
    Swal.fire({
      title: str,
      icon: 'error',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {

          //location.reload();
        }
      },
    }).then((result) => {

    });
  }


  fileValidator(control: any) {
    const files = control.value;

    if (!files || files.length === 0) {
      return null;
    }
    if (files.length + this.fileData.length > this.maxFilesAllowed) {
      return { maxFilesExceeded: true };
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!this.isValidFileFormat(file)) {
        return { invalidFormat: true };
      }

      if (file.size > this.maxFileSize) {
        return { fileSizeExceeded: true };
      }
    }

    return null;
  }

  

  onFileSelected(event: any, controlName: string) {
    const files = event.target.files;
    const errorMessages: string[] = [];
    if (!files || files.length === 0) {
      // Remove files only for the specific control
      this.fileData = this.fileData.filter(file => file.attachment_Type !== controlName);
      this.icdForm.get(controlName).setErrors({ noFileSelected: true });
      return;
    }

    // Remove previously selected files for this control while keeping others
    this.fileData = this.fileData.filter(file => file.attachment_Type !== controlName);


    const errors = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (!this.isValidFileFormat(file)) {
        errorMessages.push(
          `Invalid file format for "${file.name}". 
     Allowed formats: all image files (JPG, PNG, HEIC, etc.), PDF, Word (DOC, DOCX), Excel (XLS, XLSX), and CSV.`
        );

        ////console.log('Invalid file format:', file.name);
        errors.push({ invalidFormat: true });
      }

      if (file.size > this.maxFileSize) {
        errorMessages.push(`File size exceeds 25 MB limit for file "${file.name}".`);
        ////console.log('File size exceeds the limit:', file.name);
        errors.push({ fileSizeExceeded: true });
      }
    }

    if (errors.length > 0) {
      const combinedMessage = errorMessages.join('\n');

      this.alertService.showMessage(combinedMessage, '.', MessageSeverity.error);
      this.Showsuccesspopup1(combinedMessage);
      this.icdForm.get(controlName).setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
      const control = this.icdForm.get(controlName);
      // 🔥 CRITICAL FIX
      control?.setValue(null);
      control?.setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
      control?.markAsTouched();
      control?.updateValueAndValidity({ emitEvent: false });

      // optional: clear DOM input too
      event.target.value = '';
      return; // 👈 stop here
    } else {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
          const b64 = reader.result.toString().split(',')[1];
          this.fileData.push({ attachment_FileName: file.name, attachment_Base64: b64, attachment_Type: controlName });
        };
      }

      this.icdForm.get(controlName).setErrors(null);
    }
  }

  isInvalid(controlName: string): boolean {
    const control = this.icdForm.get(controlName);
    return control.touched && control.invalid;
  }


  isValidFileFormat(file: File): boolean {
    const allowedMimePrefixes = [
      'image/' // all image types (jpg, png, heic, webp, etc.)
    ];

    const allowedExactMimeTypes = [
      // PDF
      'application/pdf',

      // Word
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

      // Excel
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

      // CSV (different browsers report it differently)
      'text/csv',
      'application/csv',
      'text/plain'
    ];

    // 1️⃣ Primary check (modern browsers)
    if (file.type) {
      if (allowedMimePrefixes.some(prefix => file.type.startsWith(prefix))) {
        return true;
      }

      if (allowedExactMimeTypes.includes(file.type)) {
        return true;
      }
    }

    // 2️⃣ Fallback (Safari / iOS / older browsers)
    const allowedExtensions = [
      // images
      'jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif',

      // documents
      'pdf', 'doc', 'docx',

      // excel
      'xls', 'xlsx',

      // csv
      'csv'
    ];

    const extension = file.name.split('.').pop()?.toLowerCase();
    return !!extension && allowedExtensions.includes(extension);
  }

  uploadFiles() {
    //const formData = new FormData();

    //for (let i = 0; i < this.validFiles.length; i++) {
    //  formData.append('files[]', this.validFiles[i]);
    //}

    ////console.log(this.fileData)
    //this.http.post('https://example.com/upload', formData).subscribe(
    //  (response) => {
    //    //console.log('Upload successful', response);
    //  },
    //  (error) => {
    //    //console.log('Upload error', error);
    //  }
    //);
  }
  openHJPortal() {
    let url = environment.hjPortalUrl+ "/ICD_ACK/ICD_details.aspx?q=" + this.id;
    // Open the URL in a new tab
    window.open(url, '_blank');
  }
  saveData() {
    //debugger;
    this.isLoading = true;
    this.btnDisplay = false;
    this.alertService.startLoadingMessage('', 'Data Submitting...');

    // Get the form values as an object
    const formValues = this.icdForm.getRawValue();


    // Create a new instance of the ICD class
    let responseAPI = new ResponseAPI();

    // Set the properties of the ICD instance with the form values
    this.icd.US_or_CA = formValues.US_or_CA;
    //this.icd.Full_Legal_Company_Name = formValues.Full_Legal_Company_Name;
    this.icd.Years_in_Business = formValues.Years_in_Business;

    this.icd.Tax_ID = formValues.Tax_ID;

    this.icd.Company_Address1 = formValues.Company_Address1;
    this.icd.Company_Address2 = formValues.Company_Address2;
    this.icd.Company_City = formValues.Company_City;
    this.icd.Company_Postal_Code = formValues.Company_Postal_Code;
    this.icd.Company_Office_Phone = formValues.Company_Office_Phone;
    this.icd.Company_Business_Email = formValues.Company_Business_Email;
    this.icd.Company_Country = formValues.Company_Country;
    this.icd.Company_State = formValues.Company_State;
    this.icd.Company_Province = formValues.Company_Province;

     
    //this.icd.Owner_Preferred_First_Name = formValues.Owner_Preferred_First_Name;
    //this.icd.Owner_Preferred_Last_Name = formValues.Owner_Preferred_Last_Name;
    
    this.icd.Owner_Perc = formValues.Owner_Perc;
    this.icd.Owner_Address1 = formValues.Owner_Address1;
    this.icd.Owner_Address2 = formValues.Owner_Address2;
    this.icd.Owner_City = formValues.Owner_City;
    this.icd.Owner_Country = formValues.Owner_Country;
    this.icd.Owner_State = formValues.Owner_State;
    this.icd.Owner_Province = formValues.Owner_Province;
    this.icd.Owner_Postal_Code = formValues.Owner_Postal_Code;
    this.icd.Owner_Office_Phone = formValues.Owner_Mobile_Phone;
    this.icd.Owner_Home_Phone = formValues.Owner_Home_Phone;
    this.icd.Owner_Email = formValues.Owner_Email;
     
    if (this.icd.US_or_CA == "US") {
      this.icd.State_of_Incorporation = formValues.State_of_Incorporation;
      this.icd.Provinence_of_Incorporation = "";
    }
    else {
      this.icd.Provinence_of_Incorporation = formValues.Provinence_of_Incorporation;
      this.icd.State_of_Incorporation = "";
    }


    Swal.fire({
      title: 'Submitting data...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.sfDataService.CreateICDStep4(this.icd)
      .subscribe(
        data => {

          //responseAPI = data;
          // Assign the received data to the responseAPI object
          responseAPI = data;
          if (responseAPI.isSuccess && !responseAPI.isValidationError) {

            setTimeout(() => {
              this.alertService.showMessage('ICD', `Data Saved Successfully`, MessageSeverity.success);
              this.alertService.stopLoadingMessage();
              this.isLoading = false;
              //this.reset();
             // this.router.navigate(['/icd']);
              // location.reload();
              this.btnDisplay = false;
              window.scrollTo({ top: 0, behavior: 'smooth' });
              this.icdForm.disable();
              this.Showsuccesspopup('Data Saved Successfully');
            }, 200);
          }
          else {

            let errors = new ErrorList();
            errors = responseAPI.data;
            //setTimeout(() => {
            this.alertService.showMessage('ICD', `Error while saving Data`, MessageSeverity.error);
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.alertService.showStickyMessage('Unable to store data', errors.error.message, MessageSeverity.error, errors.error.errorCode);

            this.btnDisplay = true;
            //}, 200);

          }

        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
  }

  numberValidator(control: FormControl) {
    const isValid = /^\d+$/.test(control.value);
    return isValid ? null : { 'invalidNumber': true };
  }

  BindDropdowns() {
    //debugger;
    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');

    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    this.sfDataService.getMasterConfigs("US_State,Canada_Province,US_Retails,US_Campaigns,Canada_Retails,Canada_Campaigns,DeliveryTime")
      .subscribe(
        data => {
          ////console.log(data);
          //debugger;
          this.masterConfig = data;
          this.ddlUSStates = this.masterConfig.filter(a => a.type == "US_State");
          this.ddlCAProvinence = this.masterConfig.filter(a => a.type == "Canada_Province");
          this.Canada_campaignData = this.masterConfig.filter(a => a.type == "Canada_Campaigns");
          this.Canada_retailsData = this.masterConfig.filter(a => a.type == "Canada_Retails");
          this.US_campaignData = this.masterConfig.filter(a => a.type == "US_Campaigns");
          this.US_retailsData = this.masterConfig.filter(a => a.type == "US_Retails");
          this.ddlBest_Delivery_Time = this.masterConfig.filter(a => a.type == "DeliveryTime");
          this.alertService.stopLoadingMessage();
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
  }

  private mapDataToICD(data: any) {
    if (data == null) {

      this.icdForm.disable();
      this.alertService.showMessage('ICD', `This Case is not assigned to view`, MessageSeverity.error);
      this.alertService.startLoadingMessage('', 'This Case is not assigned to view');
      this.alertService.showStickyMessage('ICD', 'This Case is not assigned to view', MessageSeverity.error, "");
      this.btnDisplay = false;
      
      return;
    }
    //debugger;
    this.icdForm.controls['US_or_CA'].setValue(data.uS_or_CA);
    this.onCountryChange();
    this.icdForm.controls['Full_Legal_Company_Name'].setValue(data.full_Legal_Company_Name);
    this.icdForm.controls['Tax_ID'].setValue(data.tax_ID);
    this.icdForm.controls['State_of_Incorporation'].setValue(data.state_of_Incorporation);
    this.icdForm.controls['Date_of_Incorporation'].setValue(this.toDisplayDate(data.date_of_Incorporation));
    this.icdForm.controls['Provinence_of_Incorporation'].setValue(data.provinence_of_Incorporation);
    this.icdForm.controls['Owner_Preferred_First_Name'].setValue(data.owner_Preferred_First_Name);
    this.icdForm.controls['Owner_Preferred_Last_Name'].setValue(data.owner_Preferred_Last_Name);

    if (data.uS_or_CA != 'US') {
      this.isUS = false;
    }
    this.icdForm.controls['HUB_Manager_Contact_Email'].setValue(data.huB_Manager_Contact_Email);


    this.icdForm.controls['Company_Address1'].setValue(data.homeAddress);
    this.icdForm.controls['Company_Address2'].setValue(data.homeAddress2);
    this.icdForm.controls['Company_City'].setValue(data.homeCity);
    this.icdForm.controls['Company_Postal_Code'].setValue(data.homeZipCode);
    this.icdForm.controls['Company_Office_Phone'].setValue(data.homePhone);
    this.icdForm.controls['Company_Business_Email'].setValue(data.company_Business_Email);
    this.icdForm.controls['Company_Country'].setValue(data.homeCountry);
    this.icdForm.controls['Company_State'].setValue(data.homeState);
    this.icdForm.controls['Company_Province'].setValue(data.homeState);

    this.icdForm.controls['Owner_First_Name'].setValue(data.owner_First_Name);
    this.icdForm.controls['Owner_Last_Name'].setValue(data.owner_Last_Name);
    this.icdForm.controls['Owner_Middle_Name'].setValue(data.owner_Middle_Name);
    this.secondaryOwner = data.secondary_Owner || ''; // Feature 10


    this.icdForm.controls['Owner_Perc'].setValue(data.ownership);
    this.icdForm.controls['Owner_Address1'].setValue(data.owner_Address1);
    this.icdForm.controls['Owner_Address2'].setValue(data.owner_Address2);
    this.icdForm.controls['Owner_City'].setValue(data.owner_City);
    this.icdForm.controls['Owner_Country'].setValue(data.owner_Country);
    this.icdForm.controls['Owner_State'].setValue(data.owner_State);
    this.icdForm.controls['Owner_Province'].setValue(data.owner_State);
    this.icdForm.controls['Owner_Postal_Code'].setValue(data.owner_Postal_Code);
    this.icdForm.controls['Owner_Mobile_Phone'].setValue(data.owner_Office_Phone);
    this.icdForm.controls['Owner_Home_Phone'].setValue(data.owner_Home_Phone);
    this.icdForm.controls['Owner_Email'].setValue(data.owner_Email);

    this.icdForm.controls['HUB_Manager_Contact_Name'].setValue(data.huB_Manager_Contact_Name);
    this.icdForm.controls['HUB_Manager_Contact_Number'].setValue(data.huB_Manager_Contact_Number);

    this.icdForm.controls['SSN_SIN'].setValue(data.ssN_SIN);

    const ssnSinValue = this.icdForm.controls['SSN_SIN'].value || '';

    this.displayValue = this.maskSSN(ssnSinValue);

    this.icd.AccountID = data.accountID;

    this.icd.HUB_Manager_Contact = data.huB_Manager_Contact;
    this.icd.HUB_Manager_Contact_Name = data.huB_Manager_Contact_Name;
    this.icd.HUB_Manager_Contact_Number = data.huB_Manager_Contact_Number;
    this.icd.HUB_Manager_Contact_Email = data.huB_Manager_Contact_Email;
    this.icd.HUB_Assistance_Email = data.huB_Assistance_Email;

    this.icd.Owner_First_Name = data.owner_First_Name;
    this.icd.Owner_Last_Name = data.owner_Last_Name;
    this.icd.Owner_Name = data.owner_Name;
    this.icd.CaseID = data.caseID;
    this.icd.ContactID = data.contactID;
    this.icd.Full_Legal_Company_Name = data.full_Legal_Company_Name;
    this.icd.Owner_Preferred_First_Name= data.owner_Preferred_First_Name;
    this.icd.Owner_Preferred_Last_Name=data.owner_Preferred_Last_Name;

    if (data.icdAckReceivedOn != null) {
      this.icd.ICDAckReceivedOn = data.icdAckReceivedOn;
      this.icdForm.disable();
      this.alertService.showMessage('ICD', `Step 4 Already Completed`, MessageSeverity.success);
      this.alertService.startLoadingMessage('', 'Step 4 Already Completed');
      this.alertService.showStickyMessage('ICD', 'Step 4 Already Completed', MessageSeverity.error, "");
      this.btnDisplay = false;
      if (this.q == null) {
        this.isHJbtn = true;
      }
      this.Showsuccesspopup('Step 4 Already Completed')
    }
    this.dataEmitter.emit(this.datad);


  }


  maskSSN(value: string): string {
    if (value) {
      const sanitizedValue = value.replace(/\D/g, '');

      if (this.isUS && sanitizedValue.length === 9) {
        return 'XXX-XX-' + sanitizedValue.slice(-4);
      } else if (!this.isUS && sanitizedValue.length === 9) {

        return 'XXX-XXX-' + sanitizedValue.slice(-3);
      }
    }

    return value; // If less than 9 digits, return as is
  }


  BindData(id: string) {
    //debugger;

    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');
    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    this.sfDataService.getICDStep3(id)
      .subscribe(
        data => {
          ////console.log(data);
          //debugger;

          this.mapDataToICD(data);
          ////console.log(data);


          this.alertService.stopLoadingMessage();
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
  }

  mapLoginErrorMessage(error: string) {

    if (error === 'invalid_username_or_password') {
      return 'Invalid username or password';
    }

    if (error === 'invalid_grant') {
      return 'This account has been disabled';
    }

    return error;
  }

  offerAlternateHost() {

    if (Utilities.checkIsLocalHost(location.origin) && Utilities.checkIsLocalHost(this.configurations.baseUrl)) {
      this.alertService.showDialog('Dear Developer!\nIt appears your backend Web API service is not running...\n' +
        'Would you want to temporarily switch to the online Demo API below?(Or specify another)',
        DialogType.prompt,
        (value: string) => {
          this.configurations.baseUrl = value;
          this.alertService.showStickyMessage('API Changed!', 'The target Web API has been changed to: ' + value, MessageSeverity.warn);
        },
        null,
        null,
        null,
        this.configurations.fallbackBaseUrl);
    }
  }

  trimFormValues() {

    // Avoid setting value on file inputs. Skip controls that look like file attachments
    // (names starting with "Attach_") or whose value is a File/FileList/object.
    Object.keys(this.icdForm.controls).forEach(key => {
      // Skip known file-type controls
      if (/^Attach_/i.test(key) || /Attach/i.test(key)) {
        return;
      }

      const control = this.icdForm.get(key);
      if (!control) {
        return;
      }

      const val = control.value;

      // Skip File / FileList / object values to avoid InvalidStateError
      if (val instanceof File || (typeof FileList !== 'undefined' && val instanceof FileList) || typeof val === 'object') {
        return;
      }

      if (typeof val === 'string') {
        try {
          control.setValue(val.trim());
        } catch (e) {
          // don't break form processing on single control error
          console.warn(`trimFormValues: skipped trimming control '${key}' due to error`, e);
        }
      }
    });
  }

  reset() {
    this.formResetToggle = false;

    setTimeout(() => {
      this.formResetToggle = true;
    });
  }
  buildFormSnapshot(): Record<string, string> {
    const raw = this.icdForm.getRawValue();
    const snap: Record<string, string> = {};
    Object.keys(raw).forEach(k => {
      const ctrl = this.icdForm.get(k);
      if (ctrl && ctrl.disabled) { return; } // skip disabled/read-only fields — user cannot act on the advisory
      const v = raw[k];
      if (v !== null && v !== undefined && v !== '' && typeof v !== 'object') {
        snap[k] = String(v);
      }
    });
    return snap;
  }

  runPreSubmitReview(): void {
    this.preSubmitLoading = true;
    this.preSubmitIssues = [];
    const snapshot = this.buildFormSnapshot();
    this.agentService.getPreSubmitReview(snapshot).pipe(
      catchError(() => of({ issues: [] }))
    ).subscribe(res => {
      this.preSubmitIssues = res?.issues ?? [];
      this.preSubmitLoading = false;
    });
  }

  onPreSubmitDismiss(): void { this.showPreSubmitReview = false; }

  onPreSubmitDoSubmit(): void {
    this.showPreSubmitReview = false;
    this.saveData();
  }

  onPreSubmitRecheck(): void { this.runPreSubmitReview(); }

  onPreSubmitAutoFix(fix: { fieldName: string; suggestedFix: string }): void {
    const ctrl = this.icdForm.get(fix.fieldName);
    if (ctrl) { ctrl.setValue(fix.suggestedFix); ctrl.markAsDirty(); }
  }

  onPreSubmitNavigate(fieldName: string): void {
    const el = document.getElementById(fieldName) || document.querySelector(`[formcontrolname="${fieldName}"]`);
    if (el) (el as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }


}



